module.exports = __webpack_public_path__ + "img/1495208239.95ea63c3.jpg";